import React from "react";
import { Link } from "react-router-dom";
import { AnimatedSection } from "./IntersectionObserver.tsx";
import Logo from "./Logo.tsx";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId: string): void => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="footer-section pad-large">
      <div className="dark-container">
        <div className="footer-content">
          <div className="footer-main">
            <AnimatedSection>
              <div className="footer-brand">
                <Logo size="medium" />
                <p className="body-medium footer-tagline">
                  Премиальный e-commerce для модных брендов
                </p>
              </div>
            </AnimatedSection>

            <div className="footer-links">
              <AnimatedSection delay={1}>
                <div className="footer-column">
                  <h4 className="heading-3 footer-heading">Услуги</h4>
                  <ul className="footer-list">
                    <li>
                      <button
                        className="footer-link"
                        onClick={() => scrollToSection("services")}
                      >
                        Индивидуальные витрины
                      </button>
                    </li>
                    <li>
                      <button
                        className="footer-link"
                        onClick={() => scrollToSection("services")}
                      >
                        UX/UI и брендинг
                      </button>
                    </li>
                    <li>
                      <button
                        className="footer-link"
                        onClick={() => scrollToSection("services")}
                      >
                        Техническая поддержка
                      </button>
                    </li>
                  </ul>
                </div>
              </AnimatedSection>

              <AnimatedSection delay={2}>
                <div className="footer-column">
                  <h4 className="heading-3 footer-heading">Компания</h4>
                  <ul className="footer-list">
                    <li>
                      <button
                        className="footer-link"
                        onClick={() => scrollToSection("process")}
                      >
                        Наш процесс
                      </button>
                    </li>
                    <li>
                      <button
                        className="footer-link"
                        onClick={() => scrollToSection("contact")}
                      >
                        Контакты
                      </button>
                    </li>
                  </ul>
                </div>
              </AnimatedSection>

              <AnimatedSection delay={3}>
                <div className="footer-column">
                  <h4 className="heading-3 footer-heading">Соцсети</h4>
                  <ul className="footer-list">
                    <li><a href="https://www.instagram.com/edgekeycommerce/" className="footer-link">Instagram</a></li>
                  </ul>
                </div>
              </AnimatedSection>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-separator"></div>
            <AnimatedSection>
              <div className="footer-copyright">
                <p className="body-small">
                  © {currentYear} AGK Commerce. Все права защищены.
                </p>
                <div className="footer-legal">
                  <Link to="/privacy-policy" className="footer-link body-small">Политика конфиденциальности</Link>
                  <Link to="/terms-of-use" className="footer-link body-small">Условия использования</Link>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;